import { useTranslation } from 'react-i18next';

interface PasswordStrengthIndicatorProps {
  score: number;
}

export function PasswordStrengthIndicator({ score }: PasswordStrengthIndicatorProps) {
  const { t } = useTranslation();
  
  const getStrengthText = (score: number) => {
    switch (score) {
      case 0:
        return t('auth.passwordStrength.veryWeak');
      case 1:
        return t('auth.passwordStrength.weak');
      case 2:
        return t('auth.passwordStrength.fair');
      case 3:
        return t('auth.passwordStrength.good');
      case 4:
        return t('auth.passwordStrength.strong');
      default:
        return t('auth.passwordStrength.veryWeak');
    }
  };

  const getStrengthColor = (score: number) => {
    switch (score) {
      case 0:
        return 'bg-red-500';
      case 1:
        return 'bg-orange-500';
      case 2:
        return 'bg-yellow-500';
      case 3:
        return 'bg-green-500';
      case 4:
        return 'bg-emerald-500';
      default:
        return 'bg-red-500';
    }
  };

  return (
    <div className="space-y-2">
      <div className="h-2 w-full bg-gray-200 rounded-full">
        <div
          className={`h-full rounded-full transition-all ${getStrengthColor(score)}`}
          style={{ width: `${(score + 1) * 20}%` }}
        />
      </div>
      <p className="text-sm text-gray-600">
        {t('auth.passwordStrength.label')}: {getStrengthText(score)}
      </p>
    </div>
  );
} 